import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    getFrontMenuItemDataWithId,
    updateFrontMenuItem
} from "adminApi/FrontMenuSettingApi/FrontMenuSetting";
import { validateForm } from "utils/validation";
import { MenuRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import MenuEditForm from './Componate/MenuEditForm';
import fields from "../json/MenuLisrFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

/**
 * MenuEdit Component
 * Handles fetching existing front menu item data and submitting updates.
 */
const MenuEdit = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const { id } = useParams();

  // Initialize form state
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues } = useFormChange(
    initialValues,
    MenuRules
  );

  /**
   * Fetch Existing Menu Data
   * Hooks into the API to populate the form fields based on the menu ID.
   */
  const { loading: loadingFetch } = useFetchFormDataById(
    id, 
    formdata, 
    getFrontMenuItemDataWithId, 
    setValues
  );

  /**
   * Form Submission Logic
   * Sends the updated menu configuration to the server.
   */
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      // Production usage: Send as JSON object (FormData only needed for file uploads)
      return await updateFrontMenuItem({ 
        id, 
        data: formValues 
      });
    },
    (vals) => validateForm(vals, MenuRules),
    () => navigate(-1),
    "Menu Setting updated successfully"
  );
  
  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <MenuEditForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Menu Setting"
      />
    </>
  );
};

export default MenuEdit;
